
import { useRef } from "react";

export function useLoadMore(initialStartIndex: any, limit: any, totalCount: any, setStartIndex: any, setIsFetchMore: any, setFinalFetch: any, scrollGroundRef: any) {
  const isLoadingRef = useRef(false);

  const loadMore = () => {
    if (!isLoadingRef.current) {
      isLoadingRef.current = true;

      setStartIndex((prevIndex: any) => prevIndex + limit);
      setIsFetchMore((prev: any) => !prev);

      setTimeout(() => {
        isLoadingRef.current = false;
      }, 500); // Prevent rapid triggering
    }
  };

  const handleScroll = () => {
    const chatGround = scrollGroundRef.current;
    if (
      chatGround?.scrollTop + 1 + chatGround?.clientHeight >=
      chatGround?.scrollHeight
    ) {
      if (initialStartIndex + limit < totalCount) {
        loadMore();
      } else {
        setFinalFetch(true);
      }
    }
  };

  return { handleScroll };
};



export function formatNumberAmericanSystem(number: any) {
  if (number >= 1e6) {
    return (Math.round(number / 1e6 * 10) / 10) + 'M';
  } else if (number >= 1e3) {
    return (Math.round(number / 1e3 * 10) / 10) + 'K';
  } else {
    return Math.round(number).toString();
  }
}


export function findPercentageWithRoundOff(amount: number, total: number) {
  let percentage = (amount / total) * 100

  return Math.round(percentage);
}

export function isValidDomainName(domain: string): boolean {
  // Regular expression for a simple domain name validation
  const domainRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9]+)+$/;

  // Test if the provided domain matches the regular expression
  return domainRegex.test(domain);
}


export function isValidEmailAddress(email: string): boolean {
  email = email.trim()
  const emailRegexx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegexx.test(email);
}

export function isPasswordCreationTypeValid(password: string): boolean {
  // Password should contain at least one symbol, one capital letter, one small letter, one number, and be at least 8 characters long
  const passwordRegex = /^(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-])(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

export function formatDateTime(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',  // 'numeric' is valid here
    month: 'short',    // 'short' is valid for abbreviated month names (e.g., Dec)
    day: '2-digit',    // '2-digit' is valid here for two-digit day
    hour: '2-digit',   // '2-digit' is valid here for two-digit hour
    minute: '2-digit', // '2-digit' is valid here for two-digit minute
    hour12: true,      // 'true' is valid for 12-hour format
  };
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
  return formattedDate;
}

export const getDefaultFormData = (mode: any) => {
  return mode === 'insert'
    ? {
      firstName: '',
      lastName: '',
      displayName: '',
      email: '',
      phoneNumber: '',
      role: '1',
      profileImageUrl: '',
    }
    : {};
};

export const flagText = (flag: any) => {
  if (flag === 1) {
    return "Yes"
  }
  else {
    return "No"
  }
}
export const validatePassword = (formData: any) => {
  const errors: any = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
  if (!formData.currentPassword.trim()) {
    errors.currentPassword = "Current password is required";
  }

  if (!formData.newPassword) {
    errors.newPassword = "New password is required";
  } else if (formData.currentPassword === formData.newPassword) {
    errors.newPassword = "New password should not be the same as the current password";
  } else if (formData.newPassword.length < 8) {
    errors.newPassword = "Password should contain at least one uppercase letter, one lowercase letter, one numeric character, one special character and more than 8 characters";
  } else if (!/[A-Z]/.test(formData.newPassword) ||
    !/[a-z]/.test(formData.newPassword) ||
    !/\d/.test(formData.newPassword) ||
    !/[!@#$%^&*(),.?":{}|<>]/.test(formData.newPassword)) {
    errors.newPassword = "Password should contain at least one uppercase letter, one lowercase letter, one numeric character, one special character and more than 8 characters";
  }

  if (!formData.confirmPassword) {
    errors.confirmPassword = "Confirm password is required";
  } else if (formData.newPassword !== formData.confirmPassword) {
    errors.confirmPassword = "New password and confirm password do not match";
  }
  return errors;
};

export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_CLIENT}`,
    authority: `${process.env.REACT_APP_AUTHORITY}`,
    endSessionEndpoint: `${process.env.REACT_APP_END_SESSION_ENDPOINT}`,
    redirectUri: `${process.env.REACT_APP_REDIRECT_URI}`,
    postLogoutRedirectUri: `${process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI}`,
  },
};

export const loginRequest = {
  scopes: ["User.Read"], // Permissions you want the user to consent to
};


export const languageDetails = [
  {
    "id": 1,
    "short": "en",
    "value": "English",
    "localValue": "English",
    "threeShort": "eng",
    "code": "en"
  },
  {
    "id": 2,
    "short": "ph",
    "value": "Filipino",
    "localValue": "Filipino",
    "threeShort": "tgl",
    "code": "fil"
  },
  {
    "id": 3,
    "short": "fr",
    "value": "French",
    "localValue": "Français",
    "threeShort": "fre",
    "code": "fr"
  },
  {
    "id": 4,
    "short": "es",
    "value": "Spanish",
    "localValue": "Español",
    "threeShort": "spa",
    "code": "es"
  },
  {
    "id": 5,
    "short": "ru",
    "value": "Russian",
    "localValue": "???????",
    "threeShort": "rus",
    "code": "ru"
  },
  {
    "id": 6,
    "short": "ch",
    "value": "Chinese",
    "localValue": "??",
    "threeShort": "chi",
    "code": "zh"
  },
  {
    "id": 7,
    "short": "kr",
    "value": "Korean",
    "localValue": "???",
    "threeShort": "kor",
    "code": "ko"
  },
  {
    "id": 8,
    "short": "ge",
    "value": "German",
    "localValue": "Deutsch",
    "threeShort": "ger",
    "code": "de"
  },
  {
    "id": 9,
    "short": "ja",
    "value": "Japanese",
    "localValue": "???",
    "threeShort": "jap",
    "code": "ja"
  },
  {
    "id": 10,
    "short": "ta",
    "value": "Tamil",
    "localValue": "?????",
    "threeShort": "tam",
    "code": "ta"
  },
  {
    "id": 11,
    "short": "te",
    "value": "Telugu",
    "localValue": "??????",
    "threeShort": "tel",
    "code": "te"
  },
  {
    "id": 12,
    "short": "po",
    "value": "Portuguese",
    "localValue": "Portuguese",
    "threeShort": "por",
    "code": "pt"
  },
  {
    "id": 13,
    "short": "it",
    "value": "Italian",
    "localValue": "Italia",
    "threeShort": "ita",
    "code": "it"
  }
]

export function formatIndianDateTime(dateString: string): string {
  const date = new Date(dateString);
  const formattedDate = date
    .toLocaleString("en-US", {
      month: "short",  // e.g., "Feb"
      day: "numeric",  // e.g., "3"
      year: "numeric", // e.g., "2025"
      hour: "2-digit", // e.g., "01"
      minute: "2-digit", // e.g., "07"
      hour12: true,    // AM/PM format
      timeZone: "Asia/Kolkata",
    })
    .replace(",", ""); // Remove comma between day and year

  return formattedDate;
}


// Original → Scaled (container space)
export const scaledX = (origX: number, scaleFactor: number) => {
  return Math.round(origX * scaleFactor);
};

export const scaledY = (origY: number, scaleFactor: number) => {
  return Math.round(origY * scaleFactor);
};

// Scaled (container space) → Original
export const descaledX = (scaledX: number, scaleFactor: number) => {
  return Math.round(scaledX / scaleFactor);
};

export const descaledY = (scaledY: number, scaleFactor: number) => {
  return Math.round(scaledY / scaleFactor);
};

export const toCamelCase = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]+(.)?/g, (match, chr) => chr ? chr.toUpperCase() : '')
    .replace(/^./, (match) => match.toLowerCase());
}


export const findTrainingStatus = (statusId: string): any => {
  const trainingData = [
    {
      id: 1,
      name: "Ready for training",
      color: "bg-io-blue"
    },
    {
      id: 2,
      name: "Training in progress",
      color: "bg-io-yellow"
    },
    {
      id: 3,
      name: "Training completed",
      color: "bg-io-green"
    }

  ]
  return trainingData.find((item: any) => item.id == statusId);

}

export const getNextPageAfterDelete = (current: any, total: any) => {
  const newTotal = total - 1;

  if (newTotal <= 0) {
    // Nothing left
    return { pageNumber: 0, current: 0, total: 0 };
  }

  // Stay on the same page unless we deleted the last one
  const newCurrent = current > newTotal ? newTotal : current;

  return { pageNumber: newCurrent, current: newCurrent, total: newTotal };
}


export const convertToUTC = (localTime: any) => {
  const date = new Date(localTime);

  // Convert to UTC string
  const utcString = date.toISOString();

  return utcString;
}
export const convertUTCToLocal = (utcTime: any) => {
  if (!utcTime) return "-"; // handle null/empty safely

  const date = new Date(utcTime);

  // Format into a readable local date/time
  return date.toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true // 12-hour format with AM/PM
  });
};
export const getCurrentShiftId = (): number => {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 14) return 1;
  if (hour >= 14 && hour < 22) return 2;
  return 3;
};

export const getTodayUtcRange = (): { startDate: string; endDate: string } => {
  const now = new Date();
  const start = new Date(now);
  start.setHours(6, 0, 0, 0);
  if (now.getHours() < 6) {
    start.setDate(start.getDate() - 1);
  }
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  return { startDate: start.toISOString(), endDate: end.toISOString() };
};

export const toLocalInputValue = (date: any) => {
  if (!date) return "";
  const d = new Date(date);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0,16);
};

export const getSubdomain = (): string | null => {
    const { hostname, origin:baseUrl } = window.location;
    const hostParts = hostname.split(".");
    if (
      hostname.includes("localhost") ||
      hostname.includes("inspectionone-staging-host.azurewebsites.net") ||
      hostname.includes("inspectionone-staging-host.azurewebsites.net") ||
      hostname.includes("inspectiononeproduction.azurewebsites.net") ||
      hostname.includes("inspectiononewebproduction.azurewebsites.net") ||
      hostname.includes("inspectiononewebhoststaging.azurewebsites.net")
    ) {
      const domain = sessionStorage.getItem("domain");

      return domain;
    }
    if(process.env.REACT_APP_ONPREM_BASE_URL && baseUrl.includes(process.env.REACT_APP_ONPREM_BASE_URL)){
      return baseUrl;
    }
    
    if (hostParts.length > 2) {
      return hostParts[0];
    }
    return null;
  };

  export const mapDynmaicURL = (
  baseUrls: any,
  mappingUrls: any
) => {
  if (!baseUrls || !mappingUrls) return baseUrls;

  Object.keys(mappingUrls).forEach((key) => {
    baseUrls[key] = mappingUrls[key];
  });

  return baseUrls;
};